import React, { useState } from "react";

import {
    Box,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Tooltip,
    Typography
} from "@mui/material";

import HistoryIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";

import AxiosInstance from "../../services/AxiosInstance";
import {
    CONFIGURATION_ITEM_HISTORY_URL
} from "../../Constants/Constants";

const ConfigurationItemHistoryDialog = ({
    configurationItemId
}) => {

    const [open, setOpen] = useState(false);

    const [history, setHistory] = useState([]);

    const [loading, setLoading] = useState(false);


    const loadHistory = async () => {

        if (!configurationItemId) {
            return;
        }

        setLoading(true);

        try {

            const response =
                await AxiosInstance.get(
                    `${CONFIGURATION_ITEM_HISTORY_URL}/${configurationItemId}/history`
                );

            setHistory(
                Array.isArray(response.data)
                    ? response.data
                    : response.data?.data || []
            );

            setOpen(true);

        } catch (error) {

            console.error(
                "Unable to load Configuration Item history:",
                error
            );

        } finally {

            setLoading(false);
        }
    };


    const handleClose = () => {
        setOpen(false);
        setHistory([]);
    };


    return (
        <>

            <Tooltip title="View History">

                <IconButton
                    size="small"
                    color="primary"
                    onClick={loadHistory}
                    disabled={loading}
                >

                    {loading ? (
                        <CircularProgress size={18} />
                    ) : (
                        <HistoryIcon fontSize="small" />
                    )}

                </IconButton>

            </Tooltip>


            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
            >

                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >

                    <Typography
                        variant="h6"
                        fontWeight={600}
                    >
                        Configuration Item History
                    </Typography>

                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>

                </DialogTitle>


                <DialogContent dividers>

                    {history.length === 0 ? (

                        <Typography
                            color="text.secondary"
                            sx={{ py: 3 }}
                            textAlign="center"
                        >
                            No history found.
                        </Typography>

                    ) : (

                        <List>

                            {history.map((item, index) => (

                                <ListItem
                                    key={
                                        item.id ||
                                        `${item.action}-${index}`
                                    }
                                    divider
                                >

                                    <ListItemText

                                        primary={
                                            item.action ||
                                            item.actionType ||
                                            "Configuration Item Updated"
                                        }

                                        secondary={
                                            <Box>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    {item.actionSummary ||
                                                        item.details ||
                                                        ""}
                                                </Typography>

                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                >
                                                    {item.actionBy
                                                        ? `By: ${item.actionBy}`
                                                        : ""}

                                                    {" "}

                                                    {item.actionOn
                                                        ? ` | ${item.actionOn}`
                                                        : ""}

                                                    {item.oldValue != null || item.newValue != null
                                                        ? ` | ${item.oldValue ?? "-"} → ${item.newValue ?? "-"}`
                                                        : ""}
                                                </Typography>

                                            </Box>
                                        }
                                    />

                                </ListItem>

                            ))}

                        </List>
                    )}

                </DialogContent>

            </Dialog>

        </>
    );
};

export default ConfigurationItemHistoryDialog;